import React from "react";
import "./style.scss";
import { Col, Row } from "antd";
import { FooterContent } from "../../pagesContent/footerContent";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  const handleMenuOnclick = (path) => {
    if (path === "/menu") {
      window.open("/pdfs/menu.pdf", "_blank", "noopener,noreferrer");
      return;
    }
    navigate(path);
    if (path === "/about") {
      setTimeout(() => {
        const aboutSection = document.getElementById("aboutSection");
        if (aboutSection) {
          aboutSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  };
  return (
    <div className="footer" id="contactSection">
      <h1>
        {FooterContent.headingTop}
        <br></br>
        {FooterContent.headingBottom}
      </h1>
      <div className="footerContent">
        <Row gutter={32}>
          <Col xs={24} sm={6} lg={6}>
            <ul>
              {FooterContent.navigation.map((val) => {
                return (
                  <li>
                    <h2 onClick={() => handleMenuOnclick(val.path)}>
                      {val.label}
                    </h2>
                  </li>
                );
              })}
            </ul>
          </Col>
          <Col xs={24} sm={6} lg={6}>
            <div className="infoSection">
              <h2>{FooterContent.timingSectionHeading}</h2>
              <p>{FooterContent.days1}</p>
              <p>{FooterContent.timeSlot1}</p>
              <p>{FooterContent.days2} </p>
              <p>{FooterContent.timeSlot2}</p>
            </div>
          </Col>
          <Col xs={24} sm={6} lg={6}>
            <div className="infoSection">
              <h2>{FooterContent.addressHeading}</h2>
              <p>{FooterContent.addressText}</p>
            </div>
          </Col>
          <Col xs={24} sm={6} lg={6}>
            <div className="infoSection">
              <h2>{FooterContent.contactHeading}</h2>
              {FooterContent.contactNumbers &&
                FooterContent.contactNumbers.map((num) => <p key={num}>{num}</p>)}
            </div>
          </Col>
        </Row>
      </div>
      <p className="copyright">© {FooterContent.copyrightText}</p>
    </div>
  );
}
